import { useState } from "react";
import cx from "classnames";

import useClickAway from "../../common/useClickAway.js";

import { arrayOf, shape, string } from "prop-types";

const propTypes = {
  loggedInLinks: arrayOf(
    shape({
      href: string.isRequired,
      label: string.isRequired,
    }),
  ),
};

const LoggedIn = (props) => {
  const { loggedInLinks } = props;
  const [isOpen, setOpen] = useState(false);

  const loginRef = useClickAway({ isOpen, setOpen });

  const handleLoginClick = (e) => {
    setOpen(true);
  };

  return (
    <div
      className={cx("login-button", {
        "login-button--is-open": isOpen,
      })}
      ref={loginRef}
    >
      <button
        type="button"
        className="login-button__avatar"
        onClick={handleLoginClick}
      >
        <svg width="32" height="32" fill="none" viewBox="0 0 32 32">
          <path
            stroke="currentColor"
            strokeWidth="2"
            d="M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z"
          />
          <path
            fill="currentColor"
            d="M21.712 29.874A14.957 14.957 0 0116 31a14.957 14.957 0 01-9.869-3.703c.594-3.59 3.148-6.532 6.542-7.714a8.003 8.003 0 003.329.72 7.995 7.995 0 003.325-.72c3.394 1.183 5.948 4.123 6.542 7.714a15.008 15.008 0 01-3.966 2.497l-.19-.924v1.004z"
          />
          <path
            fill="currentColor"
            d="M11.083 12.917a4.917 4.917 0 109.834-.002 4.917 4.917 0 00-9.834.002z"
          />
        </svg>
      </button>

      <div className="login-button__dropdown">
        <div className="login-button__links">
          {loggedInLinks.map((link, i) => {
            return (
              <div key={i} className="login-button__link">
                <a href={link.href}>{link.label}</a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

LoggedIn.propTypes = propTypes;
export default LoggedIn;
